var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.346,
    height: 25.529,
    viewBox: "0 0 18.346 25.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1373.223 -384.673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1379.913 393.186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1522.081,1557.37a.492.492,0,0,1-.343-.141.63.63,0,0,1-.105-.158.513.513,0,0,1-.035-.184.491.491,0,0,1,.14-.342.5.5,0,0,1,.685,0,.481.481,0,0,1,.057.075.3.3,0,0,1,.044.083.538.538,0,0,1,.031.088.789.789,0,0,1,.009.1.508.508,0,0,1-.035.184.614.614,0,0,1-.1.158A.5.5,0,0,1,1522.081,1557.37Z",
    transform: "translate(-1519.715 -1548.865)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.8,1494.518a.482.482,0,0,1-.483-.483,3.045,3.045,0,0,1,1.132-2.319,2.078,2.078,0,0,0,.84-1.612,1.446,1.446,0,1,0-2.89,0,.483.483,0,0,1-.965,0,2.411,2.411,0,1,1,4.821,0,2.983,2.983,0,0,1-1.124,2.3,2.1,2.1,0,0,0-.848,1.635A.482.482,0,0,1,1506.8,1494.518Z",
    transform: "translate(-1504.434 -1487.645)",
    fill: "#e30613"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1373.223 384.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1551.412,1417.066h-6.2a.483.483,0,0,1-.483-.483v-6.035a.483.483,0,0,1,.82-.346l6.2,6.035a.483.483,0,0,1-.337.829Zm-5.713-.965h4.525l-4.525-4.408Z",
    transform: "translate(-1533.55 -1410.066)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.7,1435.595h-15.449a1.45,1.45,0,0,1-1.448-1.448v-22.632a1.45,1.45,0,0,1,1.448-1.448h10.219a.482.482,0,0,1,.337.137l6.2,6.035a.482.482,0,0,1,.146.346v17.563A1.45,1.45,0,0,1,1459.7,1435.595Zm-15.449-24.563a.484.484,0,0,0-.483.483v22.632a.484.484,0,0,0,.483.483H1459.7a.484.484,0,0,0,.483-.483v-17.36l-5.91-5.756Z",
    transform: "translate(-1442.801 -1410.066)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.272,1608.5h-11.586a.483.483,0,0,1,0-.965h11.586a.483.483,0,1,1,0,.965Z",
    transform: "translate(-1466.306 -1585.872)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.272,1582.1h-11.586a.483.483,0,0,1,0-.965h11.586a.483.483,0,1,1,0,.965Z",
    transform: "translate(-1466.306 -1562.367)",
    fill: "#919191"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageQuestion);
export default __webpack_public_path__ + "static/media/page-question.00ef863ce7ec4c3a4f16c2da5720f295.svg";
export { ForwardRef as ReactComponent };